import styled from 'styled-components';
// styles
import { palette } from 'cds/styles';

/**
 * 헤더 타이틀
 * @param {object} props
 * @param {string} props.message
 */
const HeaderTitleMessage = ({ message }) => {
  return <Message>{message}</Message>;
};

const Message = styled.span`
  color: ${palette.grey75};
  font-weight: 500;
`;

export default HeaderTitleMessage;
